import React, { useEffect, useState } from 'react'
import { LeadFilterModel } from '../models/superbit-api-models';
import CompDatePicker from '../components/compDatePicker/_CompDatePicker';
import StationUserSelect from '../components/_StationUserSelect';
import { LeadsModel } from '../models/LeadsModel';
import { Select } from 'antd';
import { set } from 'lodash';
import { IDNameDescriptionItemSelect } from '../components/_IDNameDescriptionItemSelect';
import { GeneralDataModel } from '../models/GeneralDataModel';
import CustomSearchHandler from './_CustomSearchHandler';
import StationReferenceSelect from './_StationReferenceSelect';

interface ExportExcelPopUpProps {
    treeDataBrunches: any[];
    allBranches: any[];
    allUsers: any[];
    saveState: boolean;
    ClosePopup: Function;
    leadsFilter: any;
    searchStatuses: any;
    LeadTopType: any;
    LeadTypes: any;
    manufacturesList: any[];
    manufactures: any[];
    vehicleModels: any[];
    VehicleSubModelAll: any[];
    agentsList: any[];
    salesPeopleListOrigin: any[];
}

const ExportExcelPopUp: React.FC<ExportExcelPopUpProps> = ({
    treeDataBrunches,
    allBranches,
    allUsers,
    saveState,
    ClosePopup,
    leadsFilter,
    searchStatuses,
    LeadTopType,
    LeadTypes,
    manufacturesList,
    manufactures,
    vehicleModels,
    VehicleSubModelAll,
    agentsList,
    salesPeopleListOrigin,
}) => {
    const leadsModel: LeadsModel = new LeadsModel();
    const generalModel: GeneralDataModel = new GeneralDataModel();

    const [filter, setFilter] = useState<any>(new LeadFilterModel(leadsFilter));
    const [clearFilter, setClearFilter] = useState<boolean>(false);
    const [selectedStatus, setSelectedStatus] = useState<string[]>([]);
    const [manufacturer, setManufacturer] = useState<string>('');
    const [VehicleModelAutocomplete, setVehicleModelAutocomplete] = useState<any[]>(vehicleModels);
    const [VehicleModelAll, setVehicleModelAll] = useState<any[]>(vehicleModels);
    const [VehicleSubModelAutocomplete, setVehicleSubModelAutocomplete] = useState<any[]>([]);
    const [selectedCarYear, setSelectedCarYear] = useState<string>('שנת יצור');
    const [carYears, setCarYears] = useState<string[]>([]);
    const [salesPeopleList, setSalesPeopleList] = useState<any[]>(salesPeopleListOrigin);
    const [selectedSaleManName, setSelectedSaleManName] = useState<string>('');


    useEffect(() => {
        // setFilter()
        console.log('treeDataBrunches', treeDataBrunches)
        const newFilter = { ...filter }
        newFilter.page = 1;
        if (leadsFilter && leadsFilter.leadType == "-1") {
            newFilter.leadType = undefined;
        }
        if (leadsFilter && leadsFilter.StatusIdsSearch) {
            setSelectedStatus(leadsFilter.StatusIdsSearch)
        }
        setFilter(newFilter)


        var carYearsList = [];
        carYearsList.push("שנת יצור");
        for (let i: number = new Date().getFullYear() + 1; i >= new Date().getFullYear() - 31; i--) {
            carYearsList.push(i + "");
        }
        setCarYears(carYearsList)



        const manufacturer: any = manufactures.find((e: any) => e.value === leadsFilter.manufacturerId);
        if (manufacturer) {
            setManufacturer(manufacturer.text)
            onManufacturerSelect(leadsFilter.manufacturerId);
        }


        const selected = salesPeopleList.find((sp: any) => sp.value == leadsFilter.salesUserId);
        if (selected) {
            setSelectedSaleManName(selected.label)
        }

    }, [])


    const exportFile = async () => {

        const newFilter = { ...filter }
        console.log('newFilter', newFilter)
        if (filter.leadType == "-1") {
            newFilter.leadType = undefined;
            setFilter(newFilter)
        }
        if (filter.policyType == '0') {
            newFilter.policyType = undefined;
            setFilter(newFilter)
        }
        if (filter.agentId == '') {
            newFilter.agentId = undefined;
            setFilter(newFilter)
        }

        console.log('filter', filter)
        let model = await leadsModel.filterToExcel(filter);
        console.log('exportFile', model)
        console.log('export')
    }

    const closePopup = () => {
        ClosePopup();
        console.log('closePopup')
    }

    const setStateData = (key: string, value: any) => {
        //set value to filter key

        const newFilter = { ...filter }
        console.log('setStateData value', value)
        if (value == null || value == undefined || value == '') {
            newFilter[key] = undefined;
        } else {
            newFilter[key] = value;
        }
        setFilter(newFilter)

        console.log('setStateData', key, value)
    }

    const onStationUserChange = (data: any) => {
        const newFilter = { ...filter };
        newFilter.BranchId = data.BranchId;
        newFilter.stationUserId = data.stationUserId;
        setFilter(newFilter)
        if (data.BranchId !== undefined || data.stationUserId !== undefined) {
            setClearFilter(false)

        }
    }

    const onStatusChange2 = (values: string[]) => {

        // let selectedStatus: string = 'סטטוס';
        // const newFilter = { ...filter };

        // if (value.toString() !== '0') {

        //     Object.keys(searchStatuses).forEach((k: string) => {
        //         if (searchStatuses[k].id == value) {
        //             const option = searchStatuses[k];
        //             selectedStatus = option.name ? option.name : 'סטטוס';
        //             newFilter.StatusIdSearch = value.toString();
        //         }
        //     });
        // } else {
        //     delete filter.StatusIdSearch;
        //     selectedStatus = 'סטטוס';
        // }
        // localStorage.setItem('lastSelectedStatus', selectedStatus)
        // setFilter(newFilter)
        // setSelectedStatus(selectedStatus)

        const stringIds = values.map(v => String(v));

        const nextFilter = { ...filter };

        console.log('onStatusChange2-stringIds', stringIds)
        if (stringIds.length === 0) {
            delete nextFilter.StatusIdsSearch;
        } else {
            nextFilter.StatusIdsSearch = stringIds; // array of string
        }

        console.log('onStatusChange2-nextFilter', nextFilter)
        // optional: store names for UX/debug
        const options = Array.isArray(searchStatuses)
            ? searchStatuses
            : Object.values(searchStatuses);
        const selectedNames: string[] = [];
        for (let i = 0; i < stringIds.length; i++) {
            const id = stringIds[i];
            const found = options.find(o => String(o.id) === id);
            console.log('onStatusChange2-found', found)
            if (found && typeof found.name === "string") {
                selectedNames.push(found.id);
            }
        }
        console.log('onStatusChange2-selectedNames', selectedNames)

        localStorage.setItem("lastSelectedStatus", JSON.stringify(selectedNames));
        setFilter(nextFilter);
        setSelectedStatus(selectedNames);

    }

    const onPolicyTypeChange = (name: string, value: any) => {
        const newFilter = { ...filter };
        newFilter[name] = value;
        newFilter['leadType'] = '-1';
        setFilter(newFilter)
    }

    const onLeadTypeChange = (name: string, value: any) => {
        const newFilter = { ...filter };
        newFilter[name] = value;
        setFilter(newFilter)
    }

    const onManufacturerChange = (e: any) => {
        const search = e.target.value;
        const newFilter = { ...filter };

        setManufacturer(search)
        const manufacturer: any = manufactures.find((e: any) => e.text === search);

        if (manufacturer) {

            setManufacturer((manufacturer as any).text)
            newFilter['manufacturerId'] = (manufacturer as any).value;
            onManufacturerSelect((manufacturer as any).value);
            setFilter(newFilter)
        } else {
            const mList = vehicleModels
            setVehicleModelAutocomplete(mList)
            setVehicleModelAll(mList)
            // this.setState({
            //     VehicleModelAutocomplete: mList,
            //     VehicleModelAll: mList
            // });
        }
    }

    const onManufacturerSelect = async (id: string) => {
        if (id) {
            const selectedManufacturer: any = manufactures.find((m: any) => m.value === id);
            // this.setStateData("manufacturer", selectedManufacturer.text);
            // this.setStateData("manufacturerId", selectedManufacturer.value);
            let data = await generalModel.getVehicleModels(id);
            const models = data.filter((i: any) => i.text !== null);


            data = await generalModel.getVehicleSubModelsByManufacturer(id);

            const subModelsList = data.filter((sm: any) => sm.label !== null && sm.label !== '').map((sm: any) => {
                let label = sm.label.trim();
                if (sm.code && sm.code !== '' && sm.code !== '0') {
                    label = `[${sm.code}]${label}`;
                }
                return {
                    code: sm.code,
                    text: sm.label.trim(),
                    label: label,
                    value: sm.val
                }
            })

            setVehicleModelAutocomplete(models)
            setVehicleModelAll(models)
            setVehicleSubModelAutocomplete(subModelsList)

        } else {

        }
    }

    const onModelChange = (e: any) => {
        const search = e.target.value;
        const newFilter = { ...filter };
        newFilter['vehicleModel'] = search;

        const model: any = VehicleModelAll.find((e: any) => e.text === search);

        if (model) {
            newFilter['vehicleModelId'] = (model as any).value;
            setFilter(newFilter)
        } else {
            newFilter['vehicleModelId'] = null;
            setFilter(newFilter)
        }

        // const models = VehicleModelAll.filter(
        //     (m: any) => {
        //         return m.text != null && m.text.indexOf(search) > -1
        //     }
        // );
    }

    const findSubModelByText = (searchTxt: any) => {
        let selectedSubModel: any = VehicleSubModelAll.find((m: any) => m.label === searchTxt);
        if (selectedSubModel) {
            return selectedSubModel;
        } else return null;
    }

    const onSubModelChange = (e: any) => {
        const search = e.target.value;
        const newFilter = { ...filter };
        newFilter['vehicleSubModel'] = search;

        let selectedSubModel: any = findSubModelByText(search);

        if (selectedSubModel) {
            onSubModelSelect(selectedSubModel.value);
            newFilter['vehicleSubModelId'] = selectedSubModel.value;
        } else {
            newFilter['vehicleSubModelId'] = '';
        }
        setFilter(newFilter)
        // const subModels = this.state.VehicleSubModelAll.filter(
        //     (m: any) => {
        //         return m.text != null && m.text.indexOf(search) > -1
        //     }
        // );
    }

    const onSubModelSelect = (id: string) => {
        const newFilter = { ...filter };
        if (id) {
            const selectedModel: any = VehicleSubModelAll.find((m: any) => m.value === id);
            newFilter['vehicleSubModel'] = selectedModel.text;
            newFilter['vehicleSubModelId'] = id;
        } else {
            newFilter['vehicleSubModel'] = '';
            newFilter['vehicleSubModelId'] = '';
        }
        setFilter(newFilter)
    }

    const onCarYearChange = (value: string) => {
        const newFilter = { ...filter };
        newFilter.carYear = value === 'שנת יצור' ? undefined : value
        setFilter(newFilter)
        setSelectedCarYear(value)
    }

    const onAgentChange = (value: string) => {
        const newFilter = { ...filter };
        newFilter.agentId = value === 'סוכן' ? undefined : value

        let salesMansListByAgent = salesPeopleListOrigin.filter((sm) => sm.agentId == value)
        setSalesPeopleList(salesMansListByAgent)
        setFilter(newFilter)
    }

    const onSalesManSelect = (value: any) => {
        const newFilter = { ...filter };
        setSelectedSaleManName(value)

        const selected = salesPeopleList.find((sp: any) => sp.label == value);
        if (selected) {
            newFilter.salesUserId = selected.value;
        } else {
            newFilter.salesUserId = undefined;
        }
        setFilter(newFilter)
    }

    const setFilterReferrer = (id: string) => {
        const newFilter = { ...filter };
        newFilter.referrerId = id;
        setFilter(newFilter)
    }


    const clearDate = (key: string) => {
        console.log('clearDate', key)
    }

    return (
        <div className="popup-wrapper small-warning">
            <section className="popup-window rtl" style={{ minHeight: '400px', minWidth: '1200px' }}>
                <div className="close-icon pointer" onClick={(e: any) => closePopup()}></div>
                <div className="popup-content">
                    <div className="popup-header">
                        <div className="popup-title">
                            יצוא לאקסל
                        </div>
                    </div>
                    <div className="popup-body">

                        <div className="filter-row-leads filter-row flex-centered flex-start flex-top">
                            <div>
                                <div className="filter-input createDateFrom">
                                    <CompDatePicker placeholder={'מתאריך פתיחה'} value={filter.createDateFrom} onChange={(date: Date) => setStateData("createDateFrom", date)} />
                                    <div className={`icon x-clear pointer ${!filter.createDateFrom ? 'hide' : ''}`} onClick={() => clearDate('createDateFrom')}></div>
                                </div>
                                <div className="filter-input closeDateFrom">
                                    <CompDatePicker placeholder={'מתאריך סגירה '} value={filter.closeDateFrom} onChange={(date: Date) => setStateData("closeDateFrom", date)} />
                                    <div className={`icon x-clear pointer ${!filter.closeDateFrom ? 'hide' : ''}`} onClick={() => clearDate('closeDateFrom')}></div>
                                </div>
                                <div className="filter-input deliveryDateFrom">
                                    <CompDatePicker placeholder={'מתאריך הצעה/חידוש'} value={filter.deliveryDateFrom} onChange={(date: Date) => setStateData("deliveryDateFrom", date)} />
                                    <div className={`icon x-clear pointer ${!filter.deliveryDateFrom ? 'hide' : ''}`} onClick={() => clearDate('deliveryDateFrom')}></div>
                                </div>
                            </div>
                            <div>
                                <div className="filter-input createDateTo">
                                    <CompDatePicker placeholder={'עד תאריך פתיחה'} value={filter.createDateTo} onChange={(date: Date) => setStateData("createDateTo", date)} />
                                    <div className={`icon x-clear pointer ${!filter.createDateTo ? 'hide' : ''}`} onClick={() => clearDate('createDateTo')}></div>
                                </div>
                                <div className="filter-input closeDateTo">
                                    <CompDatePicker placeholder={'עד תאריך סגירה '} value={filter.closeDateTo} onChange={(date: Date) => setStateData("closeDateTo", date)} />
                                    <div className={`icon x-clear pointer ${!filter.closeDateTo ? 'hide' : ''}`} onClick={() => clearDate('closeDateTo')}></div>
                                </div>
                                <div className="filter-input deliveryDateTo">
                                    <CompDatePicker placeholder={'עד תאריך הצעה/חידוש'} value={filter.deliveryDateTo} onChange={(date: Date) => setStateData("deliveryDateTo", date)} />
                                    <div className={`icon x-clear pointer ${!filter.deliveryDateTo ? 'hide' : ''}`} onClick={() => clearDate('deliveryDateTo')}></div>
                                </div>
                            </div>
                            <div>
                                <StationUserSelect data={{
                                    branches: allBranches,
                                    users: allUsers,
                                    clearFilter: clearFilter,
                                    saveState: saveState
                                }} onChange={(data: any) => onStationUserChange(data)}
                                    stationUserIdProps={filter.stationUserId}
                                />
                            </div>
                            <div>

                                <div className="filter-input">
                                    {searchStatuses ?
                                        (
                                            <>
                                                <Select
                                                    mode="multiple"
                                                    style={{ width: '100%' }}
                                                    value={selectedStatus}
                                                    onChange={onStatusChange2}
                                                    options={
                                                        (Array.isArray(searchStatuses)
                                                            ? searchStatuses
                                                            : Object.values(searchStatuses)
                                                        ).map(opt => ({
                                                            label: opt.name,
                                                            value: String(opt.id), // ensure strings
                                                        }))
                                                    }
                                                    placeholder="סטטוס"
                                                />
                                            </>
                                        ) : ""
                                    }
                                </div>
                                <div className="filter-input">
                                    <IDNameDescriptionItemSelect
                                        OnChange={(name: string, value: any) => onPolicyTypeChange(name, value)}
                                        Id={"policyType"}
                                        Value={filter.policyType ? filter.policyType : '0'}
                                        Options={LeadTopType}
                                    />

                                </div>
                                <div className="filter-input">
                                    <IDNameDescriptionItemSelect
                                        OnChange={(name: string, value: any) => onLeadTypeChange(name, value)}
                                        Id={"leadType"}
                                        Value={filter.leadType ? filter.leadType : '-1'}
                                        Options={LeadTypes}
                                        Disabled={filter.policyType !== '1'}
                                    />
                                </div>
                            </div>



                            <div>
                                <div className="filter-input">

                                    <input type='text'
                                        list="manufacturer_list"
                                        placeholder='יצרן'
                                        onChange={(e: any) => onManufacturerChange(e)}
                                        value={manufacturer ? manufacturer : ''}
                                    />
                                    <datalist id="manufacturer_list">
                                        {manufacturesList.map((o: any, i) => <option key={i} value={o.text}>{o.text}</option>)}
                                    </datalist>
                                    {/* <div className={`icon x-clear pointer ${manufacturer == '' ? 'hide' : ''}`} onClick={() => clearFilterValue('manufacturerId')}></div> */}

                                </div>
                                <div className="filter-input">
                                    <input type='text'
                                        list="model_list"
                                        placeholder='דגם'
                                        onChange={(e: any) => onModelChange(e)}
                                        value={filter && filter.vehicleModel ? filter.vehicleModel : ""}
                                    />
                                    <datalist id="model_list">
                                        {VehicleModelAutocomplete && VehicleModelAutocomplete.map((o: any, i) => <option key={i} value={o.text}>{o.text}</option>)}
                                    </datalist>
                                    {/* <div className={`icon x-clear pointer ${!filter.vehicleModel ? 'hide' : ''}`} onClick={() => clearValue('vehicleModelId')}></div> */}
                                </div>
                                <div className="filter-input">
                                    <input type='text'
                                        placeholder='קוד דגם'
                                        list="submodel_list"
                                        onChange={(e: any) => onSubModelChange(e)}
                                        value={filter && filter.vehicleSubModel ? filter.vehicleSubModel : ""}
                                    />
                                    <datalist id="submodel_list">
                                        {VehicleSubModelAutocomplete && VehicleSubModelAutocomplete.map((o: any, i) => <option key={i} value={o.label}>{o.label}</option>)}
                                    </datalist>
                                    {/* <div className={`icon x-clear pointer ${!this.state.filter.vehicleSubModel || this.state.filter.vehicleSubModel == '' ? 'hide' : ''}`} onClick={() => this.clearValue('vehicleSubModelId')}></div> */}
                                </div>
                            </div>

                            <div>
                                <div className="filter-input">
                                    <Select
                                        style={{ width: '100%' }}
                                        // defaultValue={filter.carYear && filter.carYear !== '' ? filter.carYear : 'שנת יצור'}
                                        value={filter.carYear && filter.carYear !== '' ? filter.carYear : 'שנת יצור'}
                                        onChange={onCarYearChange}
                                        options={
                                            carYears.map((year: string) => {
                                                return {
                                                    label: year,
                                                    value: year
                                                }
                                            })
                                        }
                                    />
                                </div>


                                <div className="filter-input">
                                    <Select
                                        style={{ width: '100%' }}
                                        // defaultValue={this.state.filter.agentId && this.state.filter.agentId !== '' ? this.state.filter.agentId : 'סוכן'}
                                        value={filter.agentId && filter.agentId !== '' ? filter.agentId : 'סוכן'}
                                        onChange={onAgentChange}
                                        options={
                                            [
                                                {
                                                    label: 'סוכן',
                                                    value: ""
                                                },
                                                ...agentsList.map((agent: any) => {
                                                    return {
                                                        label: agent.name,
                                                        value: agent.id
                                                    }
                                                })
                                            ]
                                        }
                                    />
                                </div>
                                <div className="filter-input">

                                    <CustomSearchHandler
                                        salesPeopleList={salesPeopleList}
                                        onSalesManSelect={(value: any) => onSalesManSelect(value)}
                                        selectedSaleManName={selectedSaleManName}
                                        clearValue={() => console.log('11 :>> ', 11)}
                                    />
                                </div>
                            </div>

                            <div>
                                <StationReferenceSelect branches={allBranches}
                                    setFilterReferrer={(id: string) => setFilterReferrer(id)}
                                />
                            </div>



                        </div>
                    </div>


                    <div className="popup-footer">


                        <button className="button blue blue-border" onClick={() => exportFile()}>
                            יצוא
                        </button>


                        <button className="button white blue-border" onClick={() => closePopup()}>
                            סגור
                        </button>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default ExportExcelPopUp